module.exports = (window.__publicpath__ || __webpack_public_path__) + "static/media/star.93171868.svg";